/**
 * Status badge — chegara/nuqtasiz, yumshoq fon + rangli matn.
 * Faqat status uchun semantik ranglar. Maks 12px, padding 4px 10px.
 */
const VARIANTS = {
  success: 'bg-success-50 text-success-700',
  warning: 'bg-warning-50 text-warning-700',
  danger: 'bg-danger-50 text-danger-700',
  primary: 'bg-primary-50 text-primary-700',
  info: 'bg-sky-50 text-sky-700',
  neutral: 'bg-gray-100 text-gray-600',
};

const StatusBadge = ({ variant = 'neutral', children, className = '' }) => (
  <span
    className={`inline-flex items-center rounded-md text-[12px] leading-none font-medium px-2.5 py-1 whitespace-nowrap ring-1 ring-inset ring-black/5 ${
      VARIANTS[variant] || VARIANTS.neutral
    } ${className}`}
  >
    {children}
  </span>
);

export default StatusBadge;
